import axios from "axios";

const baseUrl = `${process.env.REACT_APP_API_URL}/api/pirm/customers`;

const authHeaders = (loginToken) => ({
  Authorization: `Bearer ${loginToken}`,
});

export async function bootstrapCustomer({ loginToken, payload }) {
  const { data } = await axios.post(`${baseUrl}/bootstrap`, payload, {
    headers: authHeaders(loginToken),
  });
  return data;
}

export async function testSalesforceConnection({ loginToken, companyId }) {
  const { data } = await axios.get(
    `${baseUrl}/${companyId}/salesforce/test`,
    { headers: authHeaders(loginToken) }
  );
  return data;
}
